/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from "axios";
import React from "react";
import cookie from "react-cookies";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ForgotPinModal from "../../unified/ForgotPinmodal";
import { WEB_BASE_URL } from "../../unified/webbase";
import AuthModal from "./AuthModal";

class Profile extends React.Component {
  constructor() {
    super();
    this.state = {
      token: cookie.load("token"),
      enterpriseToken: cookie.load("enterpriseToken"),
      userRole: cookie.load("userRole"),
      formPassword: "",
      confirmPassword: "",
      user: {},
      Pin: "",
      showPassword: false,
      showConfirmPassword: false
    };
    this.onSave = this.onSave.bind(this);
    this.onChangePassword = this.onChangePassword.bind(this);
    this.onChangeConfirmPassword = this.onChangeConfirmPassword.bind(this);
    this.getProfile = this.getProfile.bind(this);
    this.changePassword = this.changePassword.bind(this);
    this.generateToken = this.generateToken.bind(this);
    this.setPin = this.setPin.bind(this);
    this.copyToken = this.copyToken.bind(this);
    this.togglePasswordVisibility = this.togglePasswordVisibility.bind(this);
    this.toggleConfirmPasswordVisibility = this.toggleConfirmPasswordVisibility.bind(this);
  }

  togglePasswordVisibility = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  toggleConfirmPasswordVisibility = () => {
    this.setState({ showConfirmPassword: !this.state.showConfirmPassword });
  };

  onChangePassword = (event) => {
    this.setState({
      formPassword: event.target.value,
    });
  };

  onChangeConfirmPassword = (event) => {
    this.setState({
      confirmPassword: event.target.value,
    });
  };

  onSave(event) {
    event.preventDefault();
    if (
      this.state.confirmPassword === this.state.formPassword &&
      this.state.confirmPassword !== ""
    ) {
      const id = toast.loading("Please wait...");
      axios
        .post(
          WEB_BASE_URL + "/onboarding/get-user",
          {
            newPassword: this.state.formPassword,
          },
          {
            headers: {
              authorization: this.state.token,
            },
          }
        )
        .then((res) => {
          toast.update(id, {
            render: "Profile Details Saved!!",
            type: "success",
            isLoading: false,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  getProfile() {
    //toast loading
    axios
      .get(WEB_BASE_URL + "/onboarding/get-user", {
        headers: {
          authorization: this.state.token,
        },
      })
      .then((res) => {
        console.log(res)
        this.setState({
          user: res.data.data[0],
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  changePassword() {
    const id = toast.loading("Please wait...");
    if (this.state.confirmPassword === this.state.formPassword) {
      axios
        .post(
          WEB_BASE_URL + "/onboarding/change-password",
          {
            headers: {
              authorization: this.state.token,
            },
          },
          {
            newPassword: this.state.confirmPassword,
          }
        )
        .then((res) => {
          console.log(res);
          toast.update(id, {
            render: "Profile Details Saved!!",
            type: "success",
          });
        })
        .catch((err) => {
          console.log(err);
          toast.dismiss(id);
          toast.error(id, {
            render: "" + err,
            type: "error",
            autoClose: "2000",
          });
        });
    } else {
      toast.update(id, {
        render: "Password Mismatch",
        type: "error",
        isLoading: false,
      });
    }
  }
  setPin(event) {
    this.setState({
      Pin: event.target.value,
    });
  }

  generateToken(event) {
    event.preventDefault();
    const id = toast.loading("Please wait...");
    console.log(this.state.Pin)
    axios
      .post(WEB_BASE_URL + "/onboarding/refresh-access-token", {}, {
        headers: {
          authorization: this.state.token,
        },
      })
      .then((res) => {
        if (res.data.status === "2000") {
          toast.update(id, {
            render: "" + res.data.description,
            type: "success",
            isLoading: false,
          });
          setTimeout(() => {
            toast.dismiss(id);
            this.props.navigate(0);
          }, 2000);
        } else {
          console.log(res);
          toast.update(id, {
            render: "" + res.data.description,
            type: "error",
            isLoading: false,
          });
        }
      })
      .catch((err) => {
        toast.update(id, {
          render: "Unable to refresh token at the moment",
          type: "error",
          isLoading: false,
        });
      });
  }

  copyToken() {
    const token = this.state.user?.accessToken;
    if (token) {
      navigator.clipboard.writeText(token)
        .then(() => {
          toast.success("Token Copied");
        })
        .catch((err) => {
          console.error('Failed to copy token: ', err);
          // Fallback to older method if clipboard API fails
          var copyText = document.getElementById("token");
          copyText.select();
          copyText.setSelectionRange(0, 99999);
          document.execCommand("copy");
          toast.success("Token Copied");
        });
    } else {
      toast.error("No token available to copy");
    }
  }

  componentDidMount() {
    this.getProfile();
  }

  render() {
    return (
      <main class="page-content">
        <ToastContainer
          position="top-center"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <div class="page-breadcrumb d-none d-sm-flex align-items-center">
          <div class="ps-3">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb mb-0 p-0">
                <li class="breadcrumb-item">
                  <a href="javascript:;">
                    <i class="bx bx-home-alt text-white"></i>
                  </a>
                </li>
                <li
                  class="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  User Profile
                </li>
              </ol>
            </nav>
          </div>
          {/* <div class="ms-auto">
            <div class="btn-group">
              <button type="button" class="btn btn-light">
                Settings
              </button>
              <button
                type="button"
                class="btn btn-light split-bg-light dropdown-toggle dropdown-toggle-split"
                data-bs-toggle="dropdown"
              >
                {" "}
                <span class="visually-hidden">Toggle Dropdown</span>
              </button>
              <div class="dropdown-menu dropdown-menu-right dropdown-menu-lg-end">
                {" "}
                <a class="dropdown-item" href="javascript:;">
                  Action
                </a>
                <a class="dropdown-item" href="javascript:;">
                  Another action
                </a>
                <a class="dropdown-item" href="javascript:;">
                  Something else here
                </a>
                <div class="dropdown-divider"></div>{" "}
                <a class="dropdown-item" href="javascript:;">
                  Separated link
                </a>
              </div>
            </div>
          </div> */}
        </div>

        <div class="profile-cover bg-dark"></div>

        <div class="row">
          <div class="col-12 col-lg-8">
            <div class="card shadow-sm border-0">
              <div class="card-body">
                <h5 class="mb-0">My Account</h5>
                <hr />
                <div class="card shadow-none border">
                  <div class="card-header">
                    <h6 class="mb-0">USER INFORMATION</h6>
                  </div>
                  <div class="card-body">
                    <form class="row g-3">
                      <div class="col-6">
                        <label class="form-label">Full Name</label>
                        <input
                          type="text"
                          class="form-control"
                          value={
                            this.state.user.firstName && this.state.user.lastName ? this.state.user.firstName + " " + this.state.user.lastName : ""
                          }
                          disabled
                        />
                      </div>

                      <div class="col-6">
                        <label class="form-label">Email address</label>
                        <input
                          type="text"
                          class="form-control"
                          value={this.state.user.emailAddress}
                          disabled
                        />
                      </div>
                      <div class="col-6">
                        <label class="form-label">Phone Number</label>
                        <input
                          type="text"
                          class="form-control"
                          value={this.state.user.phoneNumber}
                          disabled
                        />
                      </div>
                      <div class="col-6">
                        <label class="form-label">Dealer Name</label>
                        <input
                          type="text"
                          class="form-control"
                          value={this.state.user.businessName}
                          disabled
                        />
                      </div>
<div class="col-6">
  <label class="form-label">Role</label>
  <input
    type="text"
    class="form-control"
    value={this.state.user?.role}
    disabled
  />
</div>

{['ADMINISTRATOR', 'DEALER', 'MERCHANT']
  .includes(this.state.user?.role) && (
  <div class="col-6">
    <label class="form-label">
      Access Token
      <a
        href={void 0}
        onClick={e => e.preventDefault()}
        data-bs-toggle="modal"
        data-bs-target="#AuthModal"
        style={{ marginLeft: "100px" }}
      >
        Generate Token
      </a>
    </label>

    <input
      id="token"
      type="text"
      class="form-control"
      value={this.state.user?.accessToken}
      disabled
    />

    <label class="mt-2">
      <a
        href={void 0}
        onClick={e => {
          e.preventDefault();
          this.copyToken();
        }}
      >
        Copy Token
      </a>
    </label>
  </div>
)}
                    </form>
                  </div>
                </div>
                <div class="card shadow-none border">
                  <div class="card-header">
                    <h6 class="mb-0">Update Password</h6>
                  </div>
                  <div class="card-body">
                    <form class="row g-3">
                      <div class="col-6">
                        <label class="form-label">New Password</label>
                        <div className="input-group">
                          <input
                            type={this.state.showPassword ? "text" : "password"}
                            class="form-control"
                            onChange={this.onChangePassword}
                          />
                          <span className="input-group-text" onClick={this.togglePasswordVisibility} style={{ cursor: 'pointer' }}>
                            <i className={this.state.showPassword ? "bx bx-show" : "bx bx-hide"}></i>
                          </span>
                        </div>
                      </div>
                      <div class="col-6">
                        <label class="form-label">Confirm New Password</label>
                        <div className="input-group">
                          <input
                            type={this.state.showConfirmPassword ? "text" : "password"}
                            class="form-control"
                            onChange={this.onChangeConfirmPassword}
                          />
                          <span className="input-group-text" onClick={this.toggleConfirmPasswordVisibility} style={{ cursor: 'pointer' }}>
                            <i className={this.state.showConfirmPassword ? "bx bx-show" : "bx bx-hide"}></i>
                          </span>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div class="text-start">
                  <button
                    onClick={(e) => {
                      this.onSave(e);
                    }}
                    type="button"
                    class="btn btn-primary px-4"
                  >
                    Save Changes
                  </button>
                  <AuthModal
                    title="Enter Authenticator Code"
                    id="AuthModal"
                    formPin={this.state.Pin}
                    setPin={this.setPin}
                    onSubmit={this.generateToken}
                  ></AuthModal>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-4">
            <div class="card shadow-sm border-0 overflow-hidden">
              <div class="card-body">
                <div class="profile-avatar text-center">
                  <img
                    src="assets/images/dummy.png"
                    class="rounded-circle shadow"
                    width="120"
                    height="120"
                    alt=""
                  />
                </div>

                <div class="text-center mt-4">
                  <h4 class="mb-1"></h4>

                  <div class="mt-4"></div>
                  <h6 class="mb-1"></h6>
                </div>
                <hr />
              </div>
            </div>
          </div>
        </div>
      </main>
    );
  }
}

export default Profile;
